import React from 'react';
import Icon from '../../../components/AppIcon';

const MapLegend = ({ isVisible, onToggle }) => {
  const severityLevels = [
    {
      level: 'critical',
      color: 'bg-error',
      label: 'Critical',
      description: 'Widespread service failure',
      count: 12
    },
    {
      level: 'major',
      color: 'bg-warning',
      label: 'Major',
      description: 'Significant disruption',
      count: 28
    },
    {
      level: 'minor',
      color: 'bg-accent',
      label: 'Minor',
      description: 'Limited impact',
      count: 45
    },
    {
      level: 'resolved',
      color: 'bg-success',
      label: 'Resolved',
      description: 'Recently fixed',
      count: 156
    }
  ];

  const mapControls = [
    { icon: 'ZoomIn', label: 'Zoom In', action: 'zoom-in' },
    { icon: 'ZoomOut', label: 'Zoom Out', action: 'zoom-out' },
    { icon: 'RotateCcw', label: 'Reset View', action: 'reset' },
    { icon: 'Layers', label: 'Toggle Layers', action: 'layers' }
  ];

  if (!isVisible) {
    return (
      <button
        onClick={onToggle}
        className="fixed bottom-4 right-4 z-50 bg-card border border-border rounded-lg p-3 shadow-lg hover:shadow-xl transition-shadow"
        title="Show Map Legend"
      >
        <Icon name="Info" size={20} />
      </button>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-card border border-border rounded-lg shadow-lg max-w-xs">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-sm font-semibold text-foreground">Map Legend</h3>
        <button
          onClick={onToggle}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
      {/* Severity Levels */}
      <div className="p-4 space-y-3">
        <h4 className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
          Outage Severity
        </h4>
        {severityLevels?.map((item) => (
          <div key={item?.level} className="flex items-center space-x-3">
            <div className={`w-3 h-3 rounded-full ${item?.color}`}></div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-foreground">
                  {item?.label}
                </span>
                <span className="text-xs text-muted-foreground">
                  {item?.count}
                </span>
              </div>
              <p className="text-xs text-muted-foreground">
                {item?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Map Controls */}
      <div className="p-4 border-t border-border">
        <h4 className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-3">
          Map Controls
        </h4>
        <div className="grid grid-cols-2 gap-2">
          {mapControls?.map((control) => (
            <button
              key={control?.action}
              className="flex items-center space-x-2 p-2 text-xs text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-colors"
              title={control?.label}
            >
              <Icon name={control?.icon} size={14} />
              <span className="hidden sm:inline">{control?.label}</span>
            </button>
          ))}
        </div>
      </div>
      {/* Statistics */}
      <div className="p-4 border-t border-border bg-muted/30">
        <div className="text-xs text-muted-foreground">
          <div className="flex justify-between mb-1">
            <span>Total Incidents:</span>
            <span className="font-medium">241</span>
          </div>
          <div className="flex justify-between">
            <span>Last Updated:</span>
            <span className="font-medium">2 min ago</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapLegend;